<template>
  <div
    class='theme-location-dropdown__field-holder'
    :class="{
      'theme-input__field-holder--error': (!!errors.has(newName)),
      'theme-input__field-holder--is-disabled': disabled,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div
      class='theme-location-dropdown'
      :class="{
        'theme-location-dropdown--green': green,
        'theme-location-dropdown--blue': blue,
        'theme-location-dropdown--focused': isFocused,
      }"
    >
      <!-- reactive hidden input -->
      <input
        type="hidden"
        v-validate="'required|locations'"
        :value="JSON.stringify({ model: localModel, phrase })"
        :name="newName"
        :data-vv-as="label"
        :data-original-name="newName"
      />

      <div
        class='theme-location-dropdown__tag'
        v-for='item in localModel'
        :key='item.id'
        @click='toggleItem(item)'
      >
        <input type='hidden' :name='name' :value='item.id'/>
        <input type='hidden' :name='`_labels[${name}]`' :value='item.name'/>
        <span class='location-name'>{{ item.name }}</span>
        <span class='icon-close location-close'></span>
      </div>

      <div class='theme-location-dropdown__wrap'>
        <input
          v-model='phrase'
          class='theme-input theme-location-dropdown__input'
          type='text'
          @keyup='suggest'
          @keydown='clearTimeout'
          @keydown.enter.prevent
          :disabled='disabled'
          @focus='isFocused = true'
          @blur='onBlur'
          :placeholder='placeholder'
        />
        <span v-if="phrase" @click="clearPhrase" class="icon-clear theme-location-dropdown__icon-clear"></span>
        <span v-if="errors.has(newName)" class="icon-warning theme-input__icon theme-input__icon-error"></span>
      </div>

      <ul class='theme-location-dropdown__list' v-if='showList'>
        <li
          v-for='item in suggestions'
          class='theme-location-dropdown__item'
          :class="{ 'theme-location-dropdown__item--is-selected': item === selected }"
          :key='item.id'
          @click.prevent="pick(item)"
        >
          {{ resolve(item) }}
        </li>
      </ul>

    </div>
    <div class='theme-input__error-text' v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import field from '../admin/mixins/field';
import $ from 'jquery';
import { mapGetters } from "vuex";

export default {
  props: {
    value: { default() { return []; } },
    resolve: { default: hit => hit.name, type: Function },
    endpoint: { default: '/admin/autocomplete/locations', type: String },
    base: { default: '', type: String },
    initial: { default: '', type: String },
    isRequired: { default: false, type: Boolean },
    green: { default: false, type: Boolean },
    blue: { default: false, type: Boolean },
    placeholder: { default: '', type: String },
    data: { default: () => [], type: Array },
  },
  data() {
    return {
      ignoreOnSubmit: false,
      localModel: [],
      phrase: '',
      isPicking: false,
      showList: false,
      suggestions: [],
      selected: null,
      typingTimer: null,
      doneTypingInterval: 700,
      isFocused: false,
    };
  },
  computed: {
    ...mapGetters(["window.app.locales"])
  },
  methods: {
    prepareForSubmit() {
      // physically remove the name attribute
      this.$el.querySelector('input[name]').removeAttribute('name');
    },
    afterSubmit() {
      // restore the name
      this.$el.querySelector('input[data-original-name]').setAttribute('name', this.$el.querySelector('input[data-original-name]').dataset.originalName);
    },
    suggest(event) {
      if (this.isPicking) return;
      let keyCode = event.keyCode;

      switch (keyCode) {
        case 38:
          this.moveSelection(-1);
          break;
        case 40:
          this.moveSelection(1);
          break;
        case 13:
          this.pick(this.selected);
          break;
        default:
          this.typing();
          break;
      }
    },
    moveSelection(delta) {
      if (!this.suggestions.length) return;
      let index = _.indexOf(this.suggestions, this.selected);
      index = (index + delta + this.suggestions.length) % this.suggestions.length;
      this.selected = this.suggestions[index];
    },
    pick(item) {
      if (!item) return;
      this.isPicking = true;
      this.toggleItem(item);
      this.phrase = '';
      this.showList = false;
      this.selected = null;

      // emit update to parent
      this.$emit('input', [...this.localModel]);

      this.$nextTick(() => {
        this.isPicking = false;
        this.validateField(); // validate on pick
      });
    },
    toggleItem(item) {
      const index = this.localModel.findIndex(i => i.id === item.id);
      if (index !== -1) {
        this.localModel.splice(index, 1);
      } else {
        this.localModel.push(item);
      }
    },
    typing() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
      this.showList = true;
    },
    clearTimeout() { clearTimeout(this.typingTimer); },
    doneTyping() {
      if (!this.phrase) { this.suggestions = []; return; }
      $.get(this.endpoint + '?q=' + this.phrase).then(response => {
        this.suggestions = response;
      });
    },
    onBlur() {
      setTimeout(() => {
        this.showList = false;
        this.suggestions = [];
        this.validateField(); // validate on blur
      }, 300);
      this.isFocused = false;
    },
    clearPhrase() { this.phrase = ''; },
    validateField() {
      this.$validator.validate(this.newName);
    }
  },
  mixins: [field],
  mounted() {
    this.localModel = this.value ? [...this.value] : [];
  }
};
</script>